import * as firebase from 'firebase';
import MiscUtils from './MiscUtils'

const MessagesUtils = {

  addMembersToRoom:  (room : {}, team: {}, members: Array<Object>) => {
    const params = {
      room: room,
      team: team,
      members: members
    }

    console.log('body', JSON.stringify(params))
    // Analytics.track(Analytics.ROOM_MEMBERS_ADDED, params);
    return MiscUtils.fetchEndPoint('addUsersToRoom', params);
  },

  createTitleFromMembers : (members : any, user: Object) => {
      let membersTransformed = [];

      if (Array.isArray(members)) {
        membersTransformed = members.filter((member) => member.userId !== user.id)
                                    .map((member) => member.displayName)

      } else {
        membersTransformed = Object.keys(members)
                                   .filter((key) => key !== user.id)
                                   .map((key) => members[key].displayName)
      }

      if (membersTransformed.length === 0){
        membersTransformed.push(user.displayName);
      }

      return membersTransformed.join(", ")
  },

  sendTextMessage(
    userMetadata : { id: string, fullName: string },
    roomInfo : { id: string},
    teamInfo : { id: string},
    text : string) {

    const dbRef = firebase.database().ref();

    const messagePath = `rooms/${roomInfo.id}/messages/`;
    var newMessageId = dbRef.child(messagePath).push().key

    const updates = {};
    const serverTimestamp = firebase.database.ServerValue.TIMESTAMP;
    updates[`users/${userMetadata.id}/rooms/${teamInfo.id}/${roomInfo.id}/lastUserActTimestamp`]
      = serverTimestamp;
    updates[messagePath + newMessageId] = {
      senderId: userMetadata.id,
      senderName: userMetadata.displayName,
      metadata: {
        type: 'text',
        text: text
      },
      timestamp: firebase.database.ServerValue.TIMESTAMP,
      status: 'sent'
    }

    // Analytics.track(Analytics.MESSAGE_SENT, {
    //   message_id: newMessageId,
    //   type: 'text',
    //   text: text
    // })
    dbRef.update(updates);
  },

  sendImageMessage(userMetadata : { id: string, fullName: string },
    roomInfo : { id: string},
    teamInfo : { id: string},
    file : {}) {

    const dbRef = firebase.database().ref();

    const messagePath = `rooms/${roomInfo.id}/messages/`;
    var newMessageId = dbRef.child(messagePath).push().key

    // Upload File
    const imagePath = `${messagePath}${newMessageId}/image.jpg`;
    // Analytics.track(Analytics.IMAGE_UPLOADED, {
    //   message_id: newMessageId,
    //   type: 'message'
    // })
    firebase.storage()
      .ref(imagePath)
      .put(file)
      .then(uploadedFile => {
        const updates = {};
        const serverTimestamp = firebase.database.ServerValue.TIMESTAMP;
        updates[`users/${userMetadata.id}/rooms/${teamInfo.id}/${roomInfo.id}/lastUserActTimestamp`]
          = serverTimestamp;

        updates[messagePath + newMessageId] = {
          senderId: userMetadata.id,
          senderName: userMetadata.displayName,
          metadata: {
            type: 'image',
            dbPath: imagePath
          },
          timestamp: firebase.database.ServerValue.TIMESTAMP,
          status: 'sent'
        }

        // Analytics.track(Analytics.MESSAGE_SENT, {
        //   message_id: newMessageId,
        //   type: 'image'
        // })
        dbRef.update(updates);
      })
      .catch(err => {
        console.log('==>> ERROR uploadedFile');
        console.log(err);
          //Error
      });
  },

  createRoomWithMembers : (room : {}, team: {}, members: Array<Object>) => {
    const params = {
      room: room,
      team: team,
      members: members
    }
    console.log('body', JSON.stringify(params))

    // Analytics.track(Analytics.ROOM_CREATED, params);
    return MiscUtils.fetchEndPoint('createRoom', params);
  },

  removeMembersFromRoom : (room : {}, team: {}, members: Array<Object>) => {
    const params = {
      room: room,
      team: team,
      members: members
    }

    // Analytics.track(Analytics.ROOM_MEMBERS_REMOVED, params);
    return MiscUtils.fetchEndPoint('removeUsersFromRoom', params);
  }
}

export default MessagesUtils;



// WEBPACK FOOTER //
// ./src/infra/MessagesUtils.js